import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}))

interface SeparatorProps {
}

const Separator = ({ ...props }: SeparatorProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}></div>
  )
}

export default Separator
